
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M15.122 6.263l-1.253-.16a6.304 6.304 0 00-.38-.916l.774-.996a.99.99 0 00-.081-1.32l-1.05-1.05a.994.994 0 00-1.323-.084l-.996.774a6.278 6.278 0 00-.916-.38L9.737.88a.998.998 0 00-.99-.88H7.253a.998.998 0 00-.99.878l-.16 1.253c-.318.104-.625.23-.916.38l-.996-.774a.992.992 0 00-1.32.081l-1.05 1.05a.994.994 0 00-.084 1.323l.774.996c-.15.292-.276.598-.38.916l-1.251.16a.998.998 0 00-.88.99v1.494c0 .504.378.93.878.99l1.253.16c.104.318.231.624.38.916l-.774.996a.991.991 0 00.081 1.32l1.05 1.05c.35.36.92.396 1.323.084l.996-.774c.292.149.598.276.916.379l.16 1.25c.06.504.486.882.99.882h1.494c.504 0 .93-.378.99-.878l.16-1.253c.318-.104.624-.231.916-.38l.996.774a.991.991 0 001.32-.081l1.05-1.05a.993.993 0 00.084-1.323l-.774-.996c.15-.292.277-.598.38-.916l1.25-.16a.998.998 0 00.88-.99V7.253a.997.997 0 00-.877-.99zM8 11.333A3.337 3.337 0 014.667 8 3.337 3.337 0 018 4.667 3.337 3.337 0 0111.333 8 3.337 3.337 0 018 11.333z","fill":"#6C6C6C"}})])])
          )
        }
      }
    